import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "welfare_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "biaoti"
};
const _hoisted_5 = {
  style: {
    "font-size": "3rem",
    "color": "#41B9B2"
  }
};
const _hoisted_6 = {
  class: "gaisu"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "schedule"
};
const _hoisted_9 = {
  class: "schedule_t"
};
const _hoisted_10 = {
  class: "schedule_t_l"
};
const _hoisted_11 = {
  class: "schedule_dom",
  style: {
    "position": "relative"
  }
};
const _hoisted_12 = {
  class: "kecheng"
};
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "肌功能训练", -1))]), _createElementVNode("img", {
    src: $setup.pic,
    class: "coverUrl"
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString($setup.get_data.benefitName || ''), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
    style: {
      "width": "48%",
      "font-size": "16px",
      "font-family": "Microsoft YaHei-Regular, Microsoft YaHei",
      "font-weight": "400",
      "color": "#000000",
      "white-space": "pre-wrap"
    },
    innerHTML: $setup.get_data.benefitExplain || ''
  }, null, 8, _hoisted_7), _cache[2] || (_cache[2] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/new/image.png",
    style: {
      "width": "100%",
      "margin-top": "2rem"
    },
    alt: ""
  }, null, -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[3] || (_cache[3] = _createElementVNode("div", null, [_createElementVNode("span", {
    style: {
      "font-size": "4rem"
    }
  }, "公益训练："), _createElementVNode("h2", {
    style: {
      "font-size": "3rem",
      "color": "#41B9B2",
      "margin": "0"
    }
  }, "口腔肌功能训练(您的训练进度)")], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "schedule_dom_t",
    style: _normalizeStyle(['width:' + (($setup.get_data.status || 0) * 1 + 3) + '%;', {
      "height": "100%"
    }])
  }, null, 4), _createElementVNode("div", {
    class: "schedule_dom_m",
    style: _normalizeStyle('left:' + (($setup.get_data.status || 0) > 93 ? ($setup.get_data.status || 0) * 1 - 7 : $setup.get_data.status || 0) + '%;')
  }, [_createElementVNode("span", null, _toDisplayString($setup.get_data.status || 0) + "%", 1)], 4)])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    style: {
      "border-top": "3px dotted rgba(0,0,0,0.5)",
      "padding": "8% 0"
    }
  }, [_createElementVNode("span", {
    style: {
      "font-size": "2.3rem"
    }
  }, " 米檬口腔肌功能训练公益项目，已连续服务8年+，我们为有需要且适合（口呼吸、嘴唇闭合不良、吐舌吞咽等情况) 的儿童和青少年，提供公益指导。 ")], -1))]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    style: {
      "background": "#41B9B2",
      "margin-bottom": "0"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/welfare_details/hb_pe.png",
    style: {
      "width": "100%"
    },
    alt: ""
  })], -1))]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "biaoti"
  }, [_createElementVNode("h1", null, "课程目录")], -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.materials || [], (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.push(item),
      style: _normalizeStyle(item.hide || item.isCover == 1 ? 'display: none;' : '')
    }, [_createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/new/bf.png",
      alt: ""
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.title || ''), 1)]), _createElementVNode("span", {
      style: _normalizeStyle('color:' + (item.statusStr == '已完成' ? '#C4C4C4;' : '#41B9B0;'))
    }, _toDisplayString(item.statusStr || '') + _toDisplayString(item.statusStr == '未完成' ? '(' + (item.doneFlow || 0) + '/' + (item.uploadFlow || 0) + ')' : ''), 5)], 12, _hoisted_13);
  }), 128))])]);
}